<template>
    <div class="content">
        <div class="content_wrap">
            <!-- <h2 class="content_title"><img :src="'../assets/images/quiz.png'" alt="ox quiz"></h2> -->
            <h2 class="content_title">{{quiz.title != null ? quiz.title : 'Quiz'}}</h2>
        <div class="quiz_wrap">
            <h3 class="qtitle">
                <span class="qunum">Q{{order + 1}}.</span>
                <span class="qcont" v-html="quiz.question"></span>
            </h3>
            <form class="oxquiz">
                <ul>
                    <li>
                        <input type="radio" @click="pickAnsewer" v-model="picked" id="ox1" name="ox_answer" value="1">
                        <label for="ox1"><span class="ox_o">O</span></label>
                    </li>
                    <li>
                        <input type="radio" @click="pickAnsewer" v-model="picked" id="ox2" name="ox_answer" value="2">
                        <label for="ox2"><span class="ox_x">X</span></label>
                    </li>
                </ul>
            </form>
            <transition name="fade">
                <div v-show="explain == 'true'" class="resultbox right">
                    <div class="re_right">
                        <p class="answerbox correct">정답</p>
                        <span class="commtxt">정답 : <span class="bold">{{quiz.answer == "1" ? "O" : "X"}}</span></span>
                        <p class="answerbox comment">해설</p>
                        <span class="commtxt" v-html="quiz.explain"></span>
                    </div>
                    <div class="clearfix">
                        <a @click="goQuizNext(order + 1)" class="quizbt float_right main">다음</a>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div v-show="explain == 'false'" class="resultbox wrong">
                    <div class="re_right">
                        <p class="answerbox wrong">오답</p>
                        <span class="commtxt">정답 : <span class="bold">{{quiz.answer == "1" ? "O" : "X"}}</span></span>
                        <p class="answerbox comment">해설</p>
                        <span class="commtxt" v-html="quiz.explain"></span>
                    </div>
                    <div class="clearfix">
                        <a @click="goQuizNext(order + 1)" class="quizbt float_right main">다음</a>
                    </div>
                </div>
            </transition>
            <!-- <div class="resultbox chance">
                <div class="re_wrong">
                    <p class="wrtxt">
                        틀렸습니다. 다시 시도해주세요.
                    </p>
                </div>
            </div> -->
        </div>
        </div>
    </div>
</template>
<script>
import {pad} from '../../helpers'
export default {
    props : ['quiz','order','currentSlide'],
    data(){
        return {
            try : 0,
            picked : null,
            explain : null,
            correctSound : new Audio("../assets/media/correct_answer.mp3"),
            wrongSound : new Audio("../assets/media/incorrect.mp3"),
        }
    },
    methods:{
         pickAnsewer(e){
             //check first try or not
             if(this.try != 0){
                e.preventDefault();
                alert('다음문제로 넘어가주세요.')
                 return;
             }
             this.try ++ ;
             //corrent answer
             if(e.target.value == (this.quiz.answer)){//correct
                this.explain = 'true';
                this.$emit('answered',this.order,'correct');
                this.correctSound.play();
             }else{//wrong
                this.explain = 'false';
                this.$emit('answered',this.order,'wrong');
                this.wrongSound.play();
             }
        },
        goQuizNext(value){
            this.try = 0;
            this.$emit('goQuizNext',value);
        },
    },
    mounted(){
    }
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
